import getPlatformName from "./getPlatformName";

const tagPlatform = (): void => {
  document.body.setAttribute("data-platform", getPlatformName());
};

export default tagPlatform;
